"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _libphonenumberJs = require("libphonenumber-js");

var defaultCountryIso = 'US';

var PhoneNumberFormatter = /*#__PURE__*/function () {
  function PhoneNumberFormatter() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$countryIso = _ref.countryIso,
        countryIso = _ref$countryIso === void 0 ? defaultCountryIso : _ref$countryIso;

    (0, _classCallCheck2["default"])(this, PhoneNumberFormatter);
    this.countryIso = countryIso;
  }

  (0, _createClass2["default"])(PhoneNumberFormatter, [{
    key: "formatPhoneNumber",
    value: function formatPhoneNumber(phone) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$countryIso = _ref2.countryIso,
          countryIso = _ref2$countryIso === void 0 ? this.countryIso : _ref2$countryIso;

      return (0, _libphonenumberJs.parsePhoneNumberFromString)(phone, countryIso).formatNational();
    }
  }, {
    key: "formatPhoneNumberAsYouType",
    value: function formatPhoneNumberAsYouType(phone) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$countryIso = _ref3.countryIso,
          countryIso = _ref3$countryIso === void 0 ? this.countryIso : _ref3$countryIso;

      return new _libphonenumberJs.AsYouType(countryIso).input(phone);
    }
  }]);
  return PhoneNumberFormatter;
}();

exports["default"] = PhoneNumberFormatter;